import Api_Masterdata_v2 from 'src/api/api-masterdata-v2'
import Api_Masterdata from '../../api-masterdata'
import Api_Usermanagement from '../../api-usermanagement'

const api = new Api_Masterdata().init()
const api_masterdata = new Api_Masterdata().init()
const api_masterdata_v2 = new Api_Masterdata_v2().init()
const api_usermanagement = new Api_Usermanagement().init()

let config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
}

const getMaterialAll = (page) => {
  return api.get(`/material-product/datatable?per_page=${page}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getMaterialSearch = (
  material_group,
  material_number,
  company_code,
  plant,
  material_description,
  plant_desc,
  distribution_channel
) => {
  return api.get(
    `/material-product/datatable?material_group=${material_group}&material_number=${material_number}&company_code=${company_code}&plant=${plant}&material_description=${material_description}&plant_desc=${plant_desc}&distribution_channel=${distribution_channel}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getMaterialLisPricelist = () => {
  return api_masterdata.get('/material-product/material-for-pricelist', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getMaterialLisPricelistSearch = (code, name, price) => {
  return api_masterdata.get(
    `/material-product/material-for-pricelist?product_code=${code}&product_name=${name}&price=${price}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getCustomerAll = (page) => {
  return api.get(`/customer?per_page=${page}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSlocAll = () => {
  return api.get(`/sloc`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getBankKey = (options = {}) => {
  const _params = new URLSearchParams(options).toString()
  return api.get(`/bank-key?${_params}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCustomerSearch = (
  customer_code = '',
  name = '',
  customer_account_group = '',
  text = '',
  company_type = '',
  company_type_description = '',
  street1 = '',
  no_telp = '',
  email = ''
) => {
  return api.get(
    `/customer?customer_code=${customer_code}&name=${name}&customer_account_group=${customer_account_group}&text=${text}&company_type=${company_type}&company_type_description=${company_type_description}&street1=${street1}&no_telp=${no_telp}&email=${email}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getRouteAll = () => {
  return api.get('/route', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPlantAssignment = (per) => {
  return api.get(`/plant/assignment?per_page=${per}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPlantAssignmentSearch = (code, plant, dist, sales, dc, desc) => {
  return api.get(
    `/plant/assignment?sales_org_code=${code}&plant=${plant}&distribution_channel=${dist}&sales_org_desc=${sales}&dc_description=${dc}&plant_desc=${desc}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPlant = (per) => {
  return api.get(`/plant?per_page=${per}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllPlants = (sales_org) => {
  return api_masterdata_v2.get(`/plant/list?sales_org_code=` + sales_org, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPlantSearch = (name = null, city = null, address = null, date1 = null, date2 = null) => {
  return api.get(
    `/plant?name1=${name}&city_code=${city}&address=${address}&from_date=${date1}&to_date=${date2}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getOfficeAll = (page) => {
  return api.get(`/sales-office?per_page=${page}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getOfficeAllSearch = (sales, date1, date2, area) => {
  return api.get(
    `/sales-office?sales_office=${sales}&from_date=${date1}&to_date=${date2}&controlling_area=${area}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAreaAll = (page) => {
  return api.get(`/sales-area-assignment?per_page=${page}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAreaAllSearch = (
  sales,
  company,
  dist,
  dc,
  division,
  div_desc,
  office,
  description,
  id,
  date1,
  date2,
  controlling
) => {
  return api.get(
    `/sales-area-assignment?sales_org=${sales}&company_name=${company}&distribution_channel=${dist}&dc_description=${dc}&division=${division}&division_desc=${div_desc}&sales_office=${office}&description=${description}&sales_office_id=${id}&sales_office_from_date=${date1}&sales_office_to_date=${date2}&controlling_area=${controlling}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getMaterialGroup = () => {
  return api.get('/material-group/list', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getTopAll = () => {
  return api.get('/term-of-payment', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getTopAllSearch = (code, name) => {
  return api.get(`/term-of-payment?code=${code}&top_desc=${name}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getListMaterialAll = (plant, dist, Ccode, material) => {
  return api.get(
    `/material-product/list?plant=${plant}&distribution_channel=${dist}&company_code=${Ccode}&material_group=${material}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPPN = () => {
  return api_masterdata.get(`/ppn`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const editPPN = (data) => {
  return api_masterdata.put(`/ppn/edit?credentials=${localStorage.getItem('credential')}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllTransport = () => {
  return api_masterdata.get(`/transport-mode/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getDetailFileConfig = (sales, type, sector) => {
  return api_usermanagement.get(`/file-configuration/detail?sales_org_code=${sales}&type=${type}&sector_id=${sector || ''}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {
  getMaterialAll,
  getCustomerAll,
  getPlantAssignment,
  getPlant,
  getAllPlants,
  getOfficeAll,
  getAreaAll,
  getMaterialLisPricelist,
  getMaterialGroup,
  getMaterialSearch,
  getCustomerSearch,
  getPlantAssignmentSearch,
  getTopAll,
  getPlantSearch,
  getOfficeAllSearch,
  getAreaAllSearch,
  getMaterialLisPricelistSearch,
  getTopAllSearch,
  getListMaterialAll,
  getPPN,
  editPPN,
  getAllTransport,
  getRouteAll,
  getSlocAll,
  getBankKey,
  getDetailFileConfig,
}
